import React from 'react';
import { PxWindow } from '../components/PixelUI';

const P = ({ children, ...rest }) => (
  <p style={{ color: 'var(--nv-brown)', lineHeight: 1.75, fontSize: 13.5, margin: '0 0 12px' }} {...rest}>{children}</p>
);
const Row = ({ k, v }) => (
  <div className="nv-kv" style={{ alignItems: 'flex-start' }}>
    <span className="k" style={{ minWidth: 120 }}>{k}</span>
    <span className="v" style={{ fontSize: 12.5, lineHeight: 1.6, textAlign: 'left' }}>{v}</span>
  </div>
);
const Card = ({ title, children }) => (
  <div style={{ marginBottom: 22 }}>
    <PxWindow title={title} tape>
      <div style={{ padding: 18 }}>{children}</div>
    </PxWindow>
  </div>
);

const Docs = () => (
  <main className="nv-stars" style={{ minHeight: '85vh' }}>
    <section className="nv-section on-night" style={{ paddingTop: 40, position: 'relative', zIndex: 1 }}>
      <div className="nv-section-inner" style={{ maxWidth: 900 }}>
        <p className="nv-eyebrow">read the manual, then pull the lever</p>
        <h1 className="nv-h2" style={{ fontSize: 'clamp(26px, 5vw, 44px)' }} data-testid="docs-title">DOCS ROM</h1>
        <P style={{ color: 'var(--nv-tan)', maxWidth: 640, marginBottom: 34 }}>
          Everything you need to rent a GPU with ETH, watch it run, and (if you're the owner) run the fleet.
          Pay on Ethereum Mainnet, get a real RunPod pod, and never overpay for idle time.
        </P>

        <Card title="WHAT.IS.NANOVRAM">
          <P>
            NANOVRAM is a pixel-art GPU rental terminal. You pick a GPU core and how many hours you want,
            pay in ETH from your wallet, and a real cloud GPU pod boots for you. When your hours run out,
            the pod stops itself automatically — no idle charges.
          </P>
          <Row k="Cores" v="NV8-1 PIXEL (RTX A4000) · RTX A5000 · RTX 4090 · A100 80GB PCIe" />
          <Row k="Pay with" v="ETH on Ethereum Mainnet (MetaMask or any EIP-1193 wallet)" />
          <Row k="Extras" v="Live ETH market (Wire) + BYTE, the streaming AI market helper" />
        </Card>

        <Card title="RENT.A.GPU">
          <P>1. Open <b>Rent</b> and connect your wallet (it's switched to Ethereum Mainnet for you).</P>
          <P>2. Pick a core — sold-out cores are disabled — and drag the hours slider. Price shows in ETH + USD.</P>
          <P>3. Hit <b>Dock &amp; Pay</b>. A fresh stock check runs right before payment so you never pay for a GPU that can't be delivered.</P>
          <P>4. Pay. Until the transaction confirms on-chain the rental reads <b>awaiting confirmation</b> — no pod launches yet. Once confirmed it starts provisioning.</P>
          <P>5. Open <b>My Dies</b> (free signature) to see status, time left, and your pod's <b>Jupyter / SSH</b> connect details.</P>
        </Card>

        <Card title="MY.DIES + ALERTS">
          <P>
            My Dies is your wallet's rental history — past and running. It refreshes on its own, so if a pod
            ever fails to boot you'll see a banner right away telling you no GPU time was used and a refund is
            coming. When the ETH is back in your wallet, a second banner confirms it and links the refund
            transaction.
          </P>
        </Card>

        <Card title="RENTAL.STATUS">
          <Row k="awaiting confirmation" v="Payment seen, waiting for on-chain confirmations — no pod yet." />
          <Row k="provisioning" v="Confirmed — your RunPod pod is booting / running." />
          <Row k="expired" v="Hours ran out; the pod auto-stopped." />
          <Row k="provision failed" v="Paid but the pod couldn't boot — refundable by the owner." />
          <Row k="refunded" v="The owner returned your ETH (with a transaction link)." />
        </Card>

        <Card title="OWNER.FLEET">
          <P>
            <b>/fleet</b> is owner-only. Unlock it with a free signature from the treasury wallet, then see
            total revenue, active pods (with live refresh), and the full rentals ledger.
          </P>
          <P>You can <b>stop</b> any pod early, and for a rental stuck on <b>provision failed</b> you can hit
            <b> SEND REFUND</b> — one wallet confirmation sends the exact ETH back to the payer. The refund is
            verified on-chain and recorded so the ledger always tells the truth.</P>
        </Card>

        <Card title="SAFETY.CHECKS">
          <Row k="Server pricing" v="Prices and core names are set server-side — the browser can't cheat the amount." />
          <Row k="On-chain verify" v="Payments must land in the NANOVRAM wallet, match the amount, and confirm before any pod starts." />
          <Row k="No replays" v="One transaction can only ever create one rental." />
          <Row k="Wallet auth" v="Your rentals and controls are locked to your signed-in wallet." />
          <Row k="Private by default" v="Public receipts hide your wallet and pod IP/SSH — only you see the full connect card." />
        </Card>

        <Card title="LINKS">
          <Row k="Home" v={<a href="/" style={{ color: 'var(--nv-green)' }}>nanovram home</a>} />
          <Row k="Rent" v={<a href="/rent" style={{ color: 'var(--nv-green)' }}>rent a gpu</a>} />
          <Row k="Wire" v={<a href="/wire" style={{ color: 'var(--nv-green)' }}>eth market</a>} />
          <Row k="Byte" v={<a href="/agent" style={{ color: 'var(--nv-green)' }}>ai market helper</a>} />
          <Row k="Fleet" v={<a href="/fleet" style={{ color: 'var(--nv-green)' }}>owner console</a>} />
          <Row k="Brand" v={<a href="/brand" style={{ color: 'var(--nv-green)' }}>logo &amp; banner</a>} />
        </Card>
      </div>
    </section>
  </main>
);

export default Docs;
